const ErrorIcon = () => {
  return (
    <svg
      width="101"
      height="100"
      viewBox="0 0 101 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.624 34.2485C12.624 20.9937 23.3692 10.2485 36.624 10.2485C49.8789 10.2485 60.624 20.9937 60.624 34.2485C60.624 40.8267 57.9775 46.7867 53.6912 51.122L53.4975 51.3157C49.1622 55.602 43.2022 58.2485 36.624 58.2485C23.3692 58.2485 12.624 47.5034 12.624 34.2485ZM52.3674 54.942C47.9977 58.2715 42.5417 60.2485 36.624 60.2485C22.2646 60.2485 10.624 48.6079 10.624 34.2485C10.624 19.8891 22.2646 8.24854 36.624 8.24854C50.9834 8.24854 62.624 19.8891 62.624 34.2485C62.624 40.1664 60.6469 45.6225 57.3172 49.9923L63.1306 55.8057L64.8996 54.0367L90.7896 79.9267L82.3044 88.412L56.4144 62.522L58.1809 60.7554L52.3674 54.942ZM54.9078 52.7338L53.9477 53.6939L59.5947 59.3408L61.716 57.2195L56.069 51.5725L55.1093 52.5323C55.0425 52.5998 54.9753 52.667 54.9078 52.7338ZM59.2428 62.522L82.3044 85.5836L87.9612 79.9267L64.8996 56.8651L59.2428 62.522Z"
        fill="#F8AAB9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.9717 15.7723C39.1766 11.5453 50.8759 16.3913 55.1029 26.5962C59.3299 36.8011 54.4839 48.5005 44.279 52.7275C34.0741 56.9545 22.3748 52.1084 18.1478 41.9035C13.9208 31.6986 18.7668 19.9993 28.9717 15.7723ZM32.9722 27.3997C32.9722 29.1206 31.5772 30.5157 29.8562 30.5157C28.1353 30.5157 26.7402 29.1206 26.7402 27.3997C26.7402 25.6788 28.1353 24.2837 29.8562 24.2837C31.5772 24.2837 32.9722 25.6788 32.9722 27.3997ZM46.4302 27.3997C46.4302 29.1206 45.0352 30.5157 43.3142 30.5157C41.5933 30.5157 40.1982 29.1206 40.1982 27.3997C40.1982 25.6788 41.5933 24.2837 43.3142 24.2837C45.0352 24.2837 46.4302 25.6788 46.4302 27.3997ZM36.6242 40.5431C32.5135 40.5431 29.0018 42.3898 27.1572 45.0228L25.5191 43.8753C27.7826 40.6444 31.9428 38.5431 36.6242 38.5431C41.3051 38.5431 45.4656 40.6421 47.7292 43.8733L46.0911 45.0208C44.2468 42.3881 40.7352 40.5431 36.6242 40.5431Z"
        fill="#FDCED6"
      />
    </svg>
  );
};

export default ErrorIcon;
